import styled from 'styled-components';
export var Wrapper = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-1y00r0v-0"
})(["display:flex;flex-direction:column;gap:", ";margin-bottom:", ";"], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(2);
});
export var Title = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-1y00r0v-1"
})(["font-size:", ";line-height:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.overview.energyCertification.text.color;
});
export var CertificationsWrapper = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-1y00r0v-2"
})(["display:flex;flex-direction:column;gap:", ";"], function (props) {
  return props.theme.space(2);
});
export var Row = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y00r0v-3"
})(["display:flex;align-items:center;column-gap:", ";"], function (props) {
  return props.theme.space(2);
});
export var Text = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-1y00r0v-4"
})(["font-size:", ";line-height:", ";color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.overview.energyCertification.text.color;
});
export var SeeEnergyCertificationLink = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-1y00r0v-5"
})(["background:none;border:none;text-align:left;width:fit-content;font-size:", ";text-decoration:underline;color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.links.color;
});